module.exports = __webpack_public_path__ + "tabletSlide.jpg?217edc1f0508b7be6416247b1f91cdc5";